export const filterOptions = [
  { id: "", value: "All" },
  { id: "banking", value: "Banking" },
  { id: "angel_investors", value: "Angel Investment" },
  { id: "venture_capital", value: "Venture Capital" },
  { id: "private_acquity", value: "Private Equity" },
  { id: "debt_financing", value: "Debt Financing" },
  { id: "working_capital_financing", value: "Working Capital" },
  { id: "family_offices", value: "Family Offices" },
  { id: "initial_public_offering", value: "Initial Public Offering" },
  { id: "mergers_and_acquisitions", value: "Merger and Acquisition" },
]

export const options = [
  {
    id: "",
    value: "All",
    role: "",
  },
  {
    id: "",
    value: "All",
    role: "corporations",
  },
  {
    id: "small",
    value: "Small",
    role: "corporations",
  },
  {
    id: "medium",
    value: "Medium",
    role: "corporations",
  },
  {
    id: "large",
    value: "Large",
    role: "corporations",
  },

  {
    id: "",
    value: "All",
    role: "affiliates",
  },
  {
    id: "black_student_unions",
    value: "Black Student Union",
    role: "affiliates",
  },
  {
    id: "civic_organizations",
    value: "Civic Organization",
    role: "affiliates",
  },
  {
    id: "hbcus",
    value: "HBCU",
    role: "affiliates",
  },
  {
    id: "professional_organizations",
    value: "Professional Organization",
    role: "affiliates",
  },
  {
    id: "sororities_and_fraternities",
    value: "Sorority & Fraternity",
    role: "affiliates",
  },
  {
    id: "trade_associations",
    value: "Trade Association",
    role: "affiliates",
  },
  {
    id: "for_profit_board_of_directores_and_advisors",
    value: "For-profit Board of Directors & Advisors",
    role: "affiliates",
  },
  {
    id: "non_profit_board_of_directores_and_advisors",
    value: "Nonprofit Board of Directors & Advisors",
    role: "affiliates",
  },
  {
    id: "private_clubs_and_associations",
    value: "Private Clubs & Associations",
    role: "affiliates",
  },

  {
    id: "",
    value: "All",
    role: "financial_organizations",
  },
  {
    id: "banking",
    value: "Banking",
    role: "financial_organizations",
  },
  {
    id: "angel_investors",
    value: "Angel investors",
    role: "financial_organizations",
  },
  {
    id: "debt_financing",
    value: "Debt Financing",
    role: "financial_organizations",
  },
  {
    id: "working_capital_financing",
    value: "Working Capital Financing",
    role: "financial_organizations",
  },
  {
    id: "mergers_and_acquisitions",
    value: "Merger & Acquisition",
    role: "financial_organizations",
  },
  {
    id: "private_acquity",
    value: "Private Equity",
    role: "financial_organizations",
  },
  {
    id: "wealth_management",
    value: "Wealth Management",
    role: "financial_organizations",
  },
  {
    id: "venture_capital",
    value: "Venture Capital",
    role: "financial_organizations",
  },
  {
    id: "family_offices",
    value: "Family Offices",
    role: "financial_organizations",
  },
  {
    id: "initial_public_offering",
    value: "Initial Public Offering",
    role: "financial_organizations",
  },

  {
    id: "",
    value: "All",
    role: "international_companies",
  },
  {
    id: "businesses",
    value: "Business",
    role: "international_companies",
  },
  {
    id: "executives",
    value: "Executive",
    role: "international_companies",
  },
  {
    id: "professionals",
    value: "Professional",
    role: "international_companies",
  },
  {
    id: "students",
    value: "Student",
    role: "international_companies",
  },

  {
    id: "",
    value: "All",
    role: "billion_dollar_round_tables",
  },
  {
    id: "chief_operating_officers",
    value: "Chief Operating Officer",
    role: "billion_dollar_round_tables",
  },
  {
    id: "chief_procurement_officers",
    value: "Chief Procurement Officer",
    role: "billion_dollar_round_tables",
  },
  {
    id: "logistic_executives",
    value: "Logistics Executive",
    role: "billion_dollar_round_tables",
  },
  {
    id: "operations_executives",
    value: "Operations Executive",
    role: "billion_dollar_round_tables",
  },
  {
    id: "supplier_diversity_managers",
    value: "Supplier Diversity Manager",
    role: "billion_dollar_round_tables",
  },

  {
    id: "",
    value: "All",
    role: "corporate",
  },
  {
    id: "diversity_and_inclusion",
    value: "Diversity & Inclusion",
    role: "corporate",
  },
  {
    id: "officers",
    value: "Officer",
    role: "corporate",
  },
  {
    id: "hr_practitioners",
    value: "HR Practitioner",
    role: "corporate",
  },
  {
    id: "hiring_managers",
    value: "Hiring Manager",
    role: "corporate",
  },
  {
    id: "supplier_diversity",
    value: "Supplier Diversity",
    role: "corporate",
  },
  {
    id: "managers",
    value: "Manager",
    role: "corporate",
  },
  {
    id: "vp_engineering",
    value: "VP, Engineering",
    role: "corporate",
  },
  {
    id: "vp_product_marketing",
    value: "VP, Product Marketing",
    role: "corporate",
  },
]
